// External dependencies
import { from } from 'rxjs';
import { catchError, delay, filter, switchMap } from 'rxjs/operators';

// Local depedencies
import { getClient } from '../../../../../clients/client';
import { Order } from '../../../shared/types';
import { listOrders } from '../../list-orders/redux/actions';
import { createOrderError, createOrderSuccess } from './actions';
import { createOrderMutation } from './mutation';
import { CreateOrderActionTypes, CreateOrderInput, ValidationAllFields } from './types';

export default function createOrderEpic(action$, state$) {
  return action$.pipe(
    filter((action: ValidationAllFields) => {
      return (
        action.type === CreateOrderActionTypes.VALIDATION_ALL_FIELDS &&
        Object.keys(state$.value.createOrder.validationErrors).length === 0
      );
    }),
    switchMap(() => {
      const order = state$.value.createOrder.order;
      const input = {
        ...order,
      };

      if (!input.userId) {
        delete input.userId;
      }

      return from(createOrder(input)).pipe(
        switchMap(() => {
          const currentState = state$.value;
          const { query, filter, size } = currentState.listOrders;

          return from([createOrderSuccess(order), listOrders({ query, filter, currentPage: 1, size })]).pipe(
            delay(1500),
          );
        }),
        catchError((error) => from([createOrderError(error)])),
      );
    }),
  );
}

export async function createOrder(input: CreateOrderInput): Promise<Order> {
  const graphQLClient = await getClient();

  const {
    data: { createOrder },
  } = await graphQLClient.mutate({
    mutation: createOrderMutation,
    variables: { input },
  });

  return createOrder;
}
